import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
import '../src/gallery/v2/mapsearch';
import '../src/gallery/v2/upcoming_showings';
import '../src/stylesheets/gallery_v2.scss';
import '../src/gallery/v2/iframe_redirect';